import { render, staticRenderFns } from "./addOrEditTopic.vue?vue&type=template&id=6152f420&scoped=true&"
import script from "./addOrEditTopic.vue?vue&type=script&lang=js&"
export * from "./addOrEditTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6152f420",
  null
  
)

export default component.exports